import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { IconDiscord } from './Icons';
import './Footer.css';

const MAIN_LINKS = [
  { to: '/home',     label: 'Home' },
  { to: '/about',    label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/bots',     label: 'Products' },
  { to: '/contact',  label: 'Contact' },
  { to: '/docs',     label: 'Docs' },
  { to: '/blog',     label: 'Blog' },
];
const LEGAL_LINKS = [
  { to: '/terms',   label: 'Terms of Service' },
  { to: '/privacy', label: 'Privacy Policy' },
];
const BOT_LINKS = [
  { to: '/code-assist/home',     label: 'Code Assist' },
  { to: '/code-assist/features', label: 'Features' },
  { to: '/code-assist/invite',   label: 'Invite Bot' },
  { to: '/code-assist/about',    label: 'About Code Assist' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/home" className="footer__logo-link" aria-label="PERM Systems home">
              <Logo size={36} />
            </Link>
            <p className="footer__tagline">
              Developer-focused tools for Discord.
              Founded 2026, operated by a single developer.
            </p>
            <a href="https://discord.gg/permsystems"
               className="btn btn--sm footer__discord"
               target="_blank" rel="noopener noreferrer">
              <IconDiscord size={14} />
              Join Discord
            </a>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Company</h4>
            <ul>{MAIN_LINKS.map(({ to, label }) => (
              <li key={to}><Link to={to} className="footer__link">{label}</Link></li>
            ))}</ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Code Assist</h4>
            <ul>{BOT_LINKS.map(({ to, label }) => (
              <li key={to}><Link to={to} className="footer__link">{label}</Link></li>
            ))}</ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__col-title">Legal</h4>
            <ul>{LEGAL_LINKS.map(({ to, label }) => (
              <li key={to}><Link to={to} className="footer__link">{label}</Link></li>
            ))}</ul>
          </div>
        </div>

        <div className="footer__charity">
          <div className="footer__charity-badge">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <circle cx="7" cy="7" r="7" fill="rgba(173,216,255,0.15)"/>
              <polyline points="3.5 7 6 9.5 10.5 4" stroke="#add8ff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Free to use — always.
          </div>
          <div className="footer__charity-badge">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M7 12s-5-3.5-5-7a5 5 0 0 1 10 0c0 3.5-5 7-5 7z" fill="rgba(96,165,250,0.2)" stroke="#60a5fa" strokeWidth="1.4"/>
            </svg>
            Donations go to{' '}
            <a
              href="https://thewaterproject.org"
              className="footer__charity-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              The Water Project
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {year} PERM Systems. All rights reserved.</p>
          <p>Built for developers.</p>
        </div>
      </div>
    </footer>
  );
}